export { default } from './VideoView';
